import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M.25 5.25C.25 2.322 2.715 0 5.687 0A5.5 5.5 0 0 1 10 2.051 5.5 5.5 0 0 1 14.312 0c2.974 0 5.438 2.322 5.438 5.25 0 3.925-2.438 7.111-4.739 9.256a25 25 0 0 1-4.244 3.17 15 15 0 0 1-.383.219l-.022.012-.007.004h-.002s-.001.001-.353-.661l-.352.662-.003-.001-.007-.004-.022-.012a10 10 0 0 1-.383-.218 25 25 0 0 1-4.244-3.17C2.688 12.36.25 9.174.25 5.25m9.75 12-.352.662a.75.75 0 0 0 .704 0zm0-.862.006-.004a23.7 23.7 0 0 0 3.982-2.975c2.2-2.05 4.262-4.864 4.262-8.159 0-2.042-1.734-3.75-3.938-3.75-1.642 0-3.033.954-3.627 2.288a.75.75 0 0 1-1.37 0C8.72 2.454 7.33 1.5 5.687 1.5 3.485 1.5 1.75 3.208 1.75 5.25c0 3.295 2.062 6.109 4.261 8.159a23.7 23.7 0 0 0 3.983 2.975z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "heart-empty"}) } }